export const columns = [
  {
    name: 'Emri',
    label: 'Emri',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'Departamentet',
    label: 'Departamentet',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'Krijuar nga',
    label: 'Krijuar nga',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'Data e krijimit',
    label: 'Data\u00A0e\u00A0Krijimit',
    options: {
      filter: true,
      sort: true,
      setCellHeaderProps: () => ({
        style: {
          whiteSpace: 'nowrap',
          minWidth: '150px'
        }
      })
    }
  },
  {
    name: 'Modifikuar nga',
    label: 'Modifikuar nga',
    options: {
      filter: true,
      sort: true,
      display: false
    }
  },
  {
    name: 'Data e modifikimit',
    label: 'Data\u00A0e\u00A0Modifikimit',
    options: {
      filter: true,
      sort: true,
      display: false,
      setCellHeaderProps: () => ({
        style: {
          whiteSpace: 'nowrap',
          minWidth: '150px'
        }
      })
    }
  },
  {
    name: 'Pamje',
    label: 'Pamje',
    options: {
      filter: false,
      sort: false,
      download: false
    }
  }
]

export const options = {
  responsive: 'scroll',
  filterType: 'dropdown',
  selectableRows: 'none',
  textLabels: {
    body: {
      noMatch: 'Nuk ka të dhëna'
    }
  }
}